import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "../../../../assets/css/style.css";
import Form from './Form.js'
import PatientReviews from '../../PatientReview.js';

import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import Counter from '../../../NumCounter.js'
import "./style.css"
import Breadcrumb from '../../Breadcrum.js';

 function Index() {
  useEffect(() => {
setTimeout(()=>{
document.title="Tonsillectomy Surgery Cost Delhi | Medfirst ENT Centre";
},500);
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Tonsillectomy Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic</title>
            <meta name="description" content="Get expert Tonsillectomy Surgery in Delhi, India. Explore Tonsillectomy Treatment options, Tonsillectomy cost, and Tonsillectomy Surgery Cost at MedFirst ENT Centre." />
            <meta name="keywords" content="Tonsillectomy Surgery, Tonsillectomy cost, Tonsillectomy Surgery Cost, Tonsillectomy Treatment" />
            <link rel="canonical" href="https://entdelhi.com/tonsillectomy/" />
            <meta property="og:title" content="Tonsillectomy Surgery in Delhi, India | Treatment, Cost, Doctor, Clinic" />
            <meta property="og:description" content="Get expert Tonsillectomy Surgery in Delhi, India. Explore Tonsillectomy Treatment options, Tonsillectomy cost, and Tonsillectomy Surgery Cost at MedFirst ENT Centre." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
     <main>
        <Breadcrumb/>
        <Form />    
        <Counter />
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         
         <GetInTouch/>
      </main>
    </div>
  )
}


export default Index;